import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './header/header.component';
import { HomeNavbarComponent } from './home-navbar/home-navbar.component';
import { FooterComponent } from './footer/footer.component';
import { HomePageComponent } from './home-page/home-page.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { VerticalsComponent } from './verticals/verticals.component';
import { ClientsComponent } from './clients/clients.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { CustomSoftwareDevelopmentComponent } from './services/custom-software-development/custom-software-development.component';
import { WebDevelopmentComponent } from './services/web-development/web-development.component';
import { MobileDevelopmentComponent } from './services/mobile-development/mobile-development.component';
import { WebHostingComponent } from './services/web-hosting/web-hosting.component';
import { MaintenanceComponent } from './services/maintenance/maintenance.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { UploadCvComponent } from './careers/upload-cv/upload-cv.component';
import { AbstractComponent } from './clients/abstract/abstract.component';
import { LoginComponent } from './login/login.component';
import { OurProductsComponent } from './our-products/our-products.component';
import { ProductDetailsComponent } from './our-products/product-details/product-details.component';
import { MultiBrandScrewAirComponent } from './verticals/multi-brand-screw-air/multi-brand-screw-air.component';
import { MultiBrandPistonComponent } from './verticals/multi-brand-piston/multi-brand-piston.component';
import { MultiBrandAirDryerComponent } from './verticals/multi-brand-air-dryer/multi-brand-air-dryer.component';
import { MultiBrandWaterChillerComponent } from './verticals/multi-brand-water-chiller/multi-brand-water-chiller.component';
import { MultiBrandOilChillerComponent } from './verticals/multi-brand-oil-chiller/multi-brand-oil-chiller.component';
import { PanelAirCoolerComponent } from './verticals/panel-air-cooler/panel-air-cooler.component';
import { AirPipeLineComponent } from './air-pipe-line/air-pipe-line.component';
import { ScrewAirCompressorComponent } from './our-products/screw-air-compressor/screw-air-compressor.component';
import { PistonAirCompressorComponent } from './our-products/piston-air-compressor/piston-air-compressor.component';
import { AirDryerComponent } from './our-products/air-dryer/air-dryer.component';
import { AirReceiverTankComponent } from './our-products/air-receiver-tank/air-receiver-tank.component';
import { WaterChillerComponent } from './our-products/water-chiller/water-chiller.component';
import { OilChillerComponent } from './our-products/oil-chiller/oil-chiller.component';
import { AirAccessoriesComponent } from './our-products/air-accessories/air-accessories.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeNavbarComponent,
    FooterComponent,
    HomePageComponent,
    AboutUsComponent,
    VerticalsComponent,
    ClientsComponent,
    TestimonialsComponent,
    CustomSoftwareDevelopmentComponent,
    WebDevelopmentComponent,
    MobileDevelopmentComponent,
    WebHostingComponent,
    MaintenanceComponent,
    ContactUsComponent,
    UploadCvComponent,
    AbstractComponent,
    LoginComponent,
    OurProductsComponent,
    ProductDetailsComponent,
    MultiBrandScrewAirComponent,
    MultiBrandPistonComponent,
    MultiBrandAirDryerComponent,
    MultiBrandWaterChillerComponent,
    MultiBrandOilChillerComponent,
    PanelAirCoolerComponent,
    AirPipeLineComponent,
    ScrewAirCompressorComponent,
    PistonAirCompressorComponent,
    AirDryerComponent,
    AirReceiverTankComponent,
    WaterChillerComponent,
    OilChillerComponent,
    AirAccessoriesComponent
   ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
